export default __webpack_public_path__ + "static/Oberaudorf-c5a16cbea05843be21e9368c1abea39b.jpg";